import Modal from "react-bootstrap/Modal";
import {
  translationProcedureTypes,
  translationAnesthesiaTechniques,
} from "../../../data";

export const ViewShiftProcedureModal = ({
  isOpen,
  setIsOpen,
  shiftProcedure,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Procedimiento</h5>
      </Modal.Header>
      <Modal.Body>
        {shiftProcedure && (
          <ul className="list-unstyled mb-0 mt-0">
            <li className="d-flex ms-0">
              <h6>Doctor:</h6>
              <p className="text-muted ms-2">
                {shiftProcedure.doctor.user.firstName}{" "}
                {shiftProcedure.doctor.user.lastName}
              </p>
            </li>

            <li className="d-flex ms-0">
              <h6>Fecha y hora:</h6>
              <p className="text-muted ms-2">{shiftProcedure.procedureTime}</p>
            </li>

            <li className="d-flex ms-0">
              <h6>Fecha de registro:</h6>
              <p className="text-muted ms-2">{shiftProcedure.createdAt}</p>
            </li>

            <li className="d-flex ms-0">
              <h6>Paciente:</h6>
              <p className="text-muted ms-2">{shiftProcedure.patientName}</p>
            </li>

            <li className="d-flex ms-0">
              <h6>Documento:</h6>
              <p className="text-muted ms-2">
                {shiftProcedure.patientDocument}
              </p>
            </li>

            <li className="d-flex ms-0">
              <h6>Tipo de procedimiento:</h6>
              <p className="text-muted ms-2">
                {translationProcedureTypes[shiftProcedure.procedureType]}
              </p>
            </li>

            <li className="d-flex ms-0">
              <h6>Procedimiento realizado:</h6>
              <p className="text-muted ms-2">{shiftProcedure.procedureDone}</p>
            </li>

            <li className="d-flex ms-0">
              <h6>Localización:</h6>
              <p className="text-muted ms-2">{shiftProcedure.location}</p>
            </li>

            <li className="d-flex ms-0">
              <h6>Tuvo complicaciones:</h6>
              <p className="text-muted ms-2">
                {shiftProcedure.hasComplications ? "Si" : "No"}
              </p>
            </li>

            {shiftProcedure.complicationText && (
              <li className="d-flex ms-0">
                <h6>Complicaciones</h6>
                <p className="text-muted ms-2">
                  {shiftProcedure.complicationText}
                </p>
              </li>
            )}

            <li className="d-flex ms-0">
              <h6>Tecnica anestesica:</h6>
              <p className="text-muted ms-2">
                {translationAnesthesiaTechniques[shiftProcedure.anesthesiaTech]}
              </p>
            </li>

            {shiftProcedure.anesthesiaAnswers.map((anesthesiaAnswer) => (
              <li className="d-flex ms-0" key={anesthesiaAnswer.id}>
                <h6>{anesthesiaAnswer.question.title}</h6>
                <p className="text-muted ms-2">
                  {anesthesiaAnswer.answerValue}
                </p>
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
